export const bytesToMegabytes = (bytes: number): string => {
  return `${bytes / 1e6}MB`;
};
